"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    stopBlockSessionOffset: Number,
    sessionBlocks: Number(process.env.SESSION_BLOCKS) || 10800,
    sessionInYear: 365 * 8,
    rpc: process.env.RPC || "https://mainnet-rpc.thundercore.com",
    network: Number(process.env.NETWORK) || 108,
    stakingContract: process.env.STAKING_CONTRACT || "",
    graphUri: process.env.GRAPH_URI || "",
};
